import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { Accordion } from '@totalsoft/rocket-ui';
import { AccordionWrapper } from 'components/common/SurfaceStyles';
import DocumentScoringClassificationComponent from './DocumentScoringClassificationComponent';
import DocumentScoringDimensionPeriodListContainer from './DocumentScoringDimensionPeriodListContainer';
import DocumentScoringGridSummary from './DocumentScoringGridSummary';
import { withRights } from 'providers/RightsConsumer';
import { ScoringGridContainer } from '../styles/DocumentScoringStyles';

export const DocumentScoringGridComponent = ({ 
  scoringGrid, 
  disabled, 
  documentId, 
  siteId, 
  rights, 
  isHistory, 
  showModal,
  savingModal,
  savingIndicators,
  dimensionPeriods, 
  onImportFinancialIndicators,
  onOpenDimensionListModal,
  onCloseDimensionListModal,
  onSavePeriodDimensions,
  onAcordionChange,
  acordionExpanded
}) => {

  return (
    <>
        <ScoringGridContainer item xs={12}>
          
          {((scoringGrid.entityType === 'ASSET' && rights.scoringGridAssetRead) ||
            (scoringGrid.entityType === 'DOCPARTNER' && rights.scoringGridClientRead) ||
            (scoringGrid.entityType === 'DOCUMENT' && rights.scoringGridDocumentRead)) && (
            <Accordion
              defaultExpanded={true}
              onChange={onAcordionChange}
              title={<DocumentScoringGridSummary 
                      scoringGrid={scoringGrid} 
                      onImportFinancialIndicators={onImportFinancialIndicators} 
                      onOpenDimensionListModal={onOpenDimensionListModal} 
                      disabled={
                        disabled ||
                        isHistory ||
                        (scoringGrid.entityType === 'DOCUMENT' && !rights.scoringGridDocumentWrite) ||
                        (scoringGrid.entityType === 'DOCPARTNER' && !rights.scoringGridClientWrite) ||
                        (scoringGrid.entityType === 'ASSET' && !rights.scoringGridAssetWrite)
                      }
                      saving={savingModal || savingIndicators}
                      rights={rights}
                      acordionExpanded={acordionExpanded}
                      />}
              content={
                <Grid container>
                  {scoringGrid.classifications.length > 0 ? (
                    <AccordionWrapper
                      sx={{ width: '100%' }}
                      content={scoringGrid.classifications.map(sc => {
                        return {
                          title: sc.name,
                          content: (
                            <DocumentScoringClassificationComponent
                              documentId={documentId}
                              siteId={siteId}
                              documentScoringGridId={scoringGrid.documentScoringGridId}
                              engineScoringId={scoringGrid.scoringGridId}
                              disabled={
                                disabled ||
                                isHistory ||
                                (scoringGrid.entityType === 'DOCUMENT' && !rights.scoringGridDocumentWrite) ||
                                (scoringGrid.entityType === 'DOCPARTNER' && !rights.scoringGridClientWrite) ||
                                (scoringGrid.entityType === 'ASSET' && !rights.scoringGridAssetWrite)
                              }
                              scoringClassification={sc}
                              indicatorPeriodList={scoringGrid.financialIndicatorPeriodDimensions || []}
                              entityType={scoringGrid.entityType}
                              isHistory={isHistory}
                              viewScoringDetailLimits={rights.viewScoringDetailLimits || false}
                              scoringGridCategoryScoreRead={rights.scoringGridCategoryScoreRead || false}
                            />
                          ),
                          defaultExpanded: true
                        };
                      })}
                    />
                  ) : (
                    ''
                  )}
                </Grid>
              }
            />
          )}
        </ScoringGridContainer>

        <DocumentScoringDimensionPeriodListContainer
        showModal={showModal}
        savingModal={savingModal}
        onCloseDimensionListModal={onCloseDimensionListModal}
        dimensions={dimensionPeriods}
        periods={scoringGrid.financialIndicatorPeriodDimensions || []}
        onSavePeriodDimensions={onSavePeriodDimensions}
        documentScoringGridId={scoringGrid.documentScoringGridId}
        />
    </>
  );
};

DocumentScoringGridComponent.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  scoringGrid: PropTypes.object.isRequired,
  rights: PropTypes.object.isRequired,
  isHistory: PropTypes.bool,
  dimensionPeriods: PropTypes.array,
  disabled: PropTypes.bool,
  showModal: PropTypes.bool,
  savingModal: PropTypes.bool,
  savingIndicators: PropTypes.bool,
  onImportFinancialIndicators: PropTypes.func,
  onOpenDimensionListModal: PropTypes.func,
  onCloseDimensionListModal: PropTypes.func,
  onSavePeriodDimensions: PropTypes.func,
  onAcordionChange: PropTypes.func,
  acordionExpanded: PropTypes.bool
};

export default withRights(DocumentScoringGridComponent);
